import { render } from "./ConversationHistory.vue?vue&type=template&id=d832588a&ts=true"
import script from "./ConversationHistory.vue?vue&type=script&lang=ts"
export * from "./ConversationHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__